import Map from "../components/core/Map.tsx";
import ChatCompact from "../components/chat/core/ChatCompact.tsx";
import {
  IconAlertCircle,
  IconChevronRight,
  IconDots,
  IconHandStop,
  IconMessage2Cancel,
  IconMessage2Cog,
  IconTrash,
} from "@tabler/icons-react";
import { useChats } from "../fetch/fetch.chat";
import ErrMessage from "../components/core/ErrMessage";
import PopUp, { closeEveryModal, openModal } from "../components/core/PopUp";
import PopUpDialog from "../components/core/PopUpDialog";
import { Link } from "react-router-dom";
import { ROUTE_CHAT, ROUTE_PRODUCT } from "../const/routes";
import Footer from "../components/Footer";
import { usePutChatState } from "../hooks/usePutChatState";
import Alert from "../components/core/Alert.tsx";
import FetchChat from "../components/messages/fetch/FetchChat.tsx";
import { CHAT_STATUS, ChatStatusType } from "../types/Chat.ts";
import { useLayoutEffect } from "react";
import { LOADING_CIRCLE } from "../components/core/loading/LoadingCircle.tsx";
import SEO from "../components/core/SEO.tsx";

function ChatList(id: string) {
  return (
    <li
      key={id}
      className="list-row cursor-pointer rounded-box glass-blurry p-2 gap-2 bg-base-100/40 items-center justify-between w-full"
    >
      <Link to={ROUTE_CHAT(id)} className="w-full list-col-grow">
        <div className="flex gap-4">
          <ChatCompact id={id} />
        </div>
      </Link>

      <button
        className="btn btn-square glass-blurry absolute z-1 right-4"
        onClick={() => {
          openModal(`chat-setting-${id}`);
        }}
      >
        <IconDots />
      </button>
    </li>
  );
}
function ChatPage() {
  const { putChatState, loading, error } = usePutChatState();
  const { chatsId, isLoading, isError } = useChats([]);
  useLayoutEffect(() => scrollTo({ top: 0, behavior: "instant" }), []);

  if (isError) return <ErrMessage message={isError.message} />;
  const setChatState = async (chatId: string, state: ChatStatusType) => {
    await putChatState(chatId, state);
    if (error) console.error(error);
    closeEveryModal();
  };
  return (
    <div className="safe-bottom-with-dock z-11">
      <SEO
        title="Nachrichten"
        description="Deine Nachrichten auf Surfanzeigen.de."
        url="/nachrichten"
        noIndex
      />
      <div className="relative safe-top-with-hanger flex flex-col gap-5 items-center bg-[url(/background.png)] bg-[50%_20%] lg:bg-[60%_50%] bg-cover">
        <div className="absolute inset-0 bg-gradient-to-b from-info/60 via-accent/20 to-base-300" />
        <Map values={chatsId}>
          {(id: string) => (
            <PopUp
              id={`chat-setting-${id}`}
              key={id}
              title={
                <>
                  <IconMessage2Cog />
                  Einstellung
                </>
              }
            >
              <div className="flex flex-col gap-3">
                <FetchChat id={id} fallback={LOADING_CIRCLE}>
                  {(chat) => (
                    <Link
                      className="flex rounded-box glass-blurry p-2 gap-2 cursor-pointer"
                      to={ROUTE_PRODUCT(chat.productId)}
                    >
                      <ChatCompact id={id} />
                    </Link>
                  )}
                </FetchChat>

                <Link className="btn w-full " to={ROUTE_CHAT(id)}>
                  <IconChevronRight />
                  Öffnen
                </Link>
                <PopUpDialog
                  title={
                    <>
                      <IconAlertCircle />
                      Chat beenden
                    </>
                  }
                  id={`dialog-chat-block-${id}`}
                  loading={loading}
                  onClick={() => setChatState(id, CHAT_STATUS.BLOCKED)}
                  className="btn w-full text-info"
                  description={
                    <Alert
                      icon={<IconAlertCircle />}
                      text={
                        "Der Chat wird beendet und für diese Anzeige wirst du von dem betroffenen Nutzer keine weiteren Nachrichten mehr erhalten."
                      }
                    />
                  }
                >
                  <IconHandStop />
                  Kommunkation beenden
                </PopUpDialog>
                <PopUpDialog
                  id={`dialog-chat-delete-${id}`}
                  title={
                    <>
                      <IconTrash />
                      Beenden & Löschen?
                    </>
                  }
                  loading={loading}
                  onClick={() => setChatState(id, CHAT_STATUS.DELETED)}
                  className="btn w-full text-error"
                  description={
                    <Alert
                      icon={<IconAlertCircle />}
                      text={"Der Chat wird gelöscht und beendet. "}
                    />
                  }
                >
                  <IconTrash />
                  Beenden & Löschen
                </PopUpDialog>
              </div>
            </PopUp>
          )}
        </Map>

        <main className="flex flex-col p-page min-h-lvh items-center w-full gap-2 z-1">
          <ul className="list bg-base-200 rounded-box w-full xl:w-1/2 md:w-2/3 gap-2 p-2">
            <li className="p-4 text-xs tracking-wide">Deine Chats</li>
            {chatsId.map(ChatList)}
          </ul>
          {isLoading && (
            <div className={"badge badge-soft"}>{LOADING_CIRCLE}</div>
          )}

          {!isLoading && chatsId.length === 0 && (
            <Alert
              icon={<IconMessage2Cancel />}
              text="Keine Chats vorhanden."
            />
          )}
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default ChatPage;
